import { Notification, NotificationType } from "./notification.types"
import {
  getMeasuresMissingText,
  getPreventionActionWithoutDateText,
  NOTIFICATION_DEFINITIONS
} from "./notification.definitions"

interface NotificationContext {
  documentNeedsGeneration: boolean
  documentNotifications: NotificationType[]
  preventionActionsWithoutDate: Array<{ id: string; name: string }>
  //Un item par risque sans aucune mesure : la tache ouvre l'etape Prevention de leur fiche
  risksWithoutMeasure: Array<{ id: string; name: string }>
  //Au moins une enquete RPS non rattachee : une seule tache, quel que soit leur nombre
  hasRpsSurveyToLink: boolean
}

function getActiveNotificationTypes(context: NotificationContext): NotificationType[] {
  const types: NotificationType[] = []

  if (context.documentNeedsGeneration) {
    types.push("document-needs-generation")
  }

  types.push(...context.documentNotifications)

  if (context.risksWithoutMeasure.length) {
    types.push("measures-missing")
  }

  if (context.preventionActionsWithoutDate.length) {
    types.push("prevention-actions-without-date")
  }

  if (context.hasRpsSurveyToLink) {
    types.push("rps-survey-to-link")
  }

  return types
}

export function getComputedNotifications(context: NotificationContext): Notification[] {
  const activeTypes = getActiveNotificationTypes(context)

  return NOTIFICATION_DEFINITIONS.filter((definition) => activeTypes.includes(definition.type)).flatMap<Notification>(
    (definition) => {
      //Ces types se declinent par item ; les documents restent une tache unique par type.
      if (definition.type === "measures-missing") {
        return context.risksWithoutMeasure.map((risk) => ({
          ...definition,
          id: `${definition.type}-${risk.id}`,
          itemId: risk.id,
          text: getMeasuresMissingText(risk.name) || definition.text,
          date: new Date()
        }))
      }

      if (definition.type === "prevention-actions-without-date") {
        return context.preventionActionsWithoutDate.map((action) => ({
          ...definition,
          id: `${definition.type}-${action.id}`,
          itemId: action.id,
          text: getPreventionActionWithoutDateText(action.name) || definition.text,
          date: new Date()
        }))
      }

      return [{ ...definition, id: definition.type, date: new Date() }]
    }
  )
}
